import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getBreachResponsibleAreaList as getBreachResponsibleAreaListApi } from '../../helpers/breach_responsible_area/api_helper';

export const getBreachResponsibleAreaList = createAsyncThunk(
	'breachResponsibleArea/getBreachResponsibleAreaList',
	async params => {
		try {
			const response = await getBreachResponsibleAreaListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener areas responsables.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
